<template>
  <div>
    <top-header></top-header>
    <el-row :gutter="20" class="top-container">
      <el-col :span="6" >
        <div class="tea-info-container">
          <el-image :src="studentInfo.headimg" class="tea-info-left">
            <div slot="error" class="image-slot">
              <img src="../../assets/userinfo/user_info_default_head.png" style="height: 80px;width: 80px;"/>
            </div>
          </el-image>
          <div class="tea-info-right">
            <p style="font-size: 20px;padding-top: 30px;padding-left: 10px;text-overflow: ellipsis;overflow: hidden;white-space: nowrap;">{{studentInfo.nickname}}</p>
            <p style="font-size: 14px;padding-top: 30px;padding-left: 10px">{{studentInfo.mobile}}</p>
          </div>
        </div>
      </el-col>
      <el-col :span="18" >
        <div style="background-color: #EFF1F6;height: 130px;">
          <el-row>
            <el-col :span="8">
              <div style="text-align: center;">
                <p style="font-size: 20px;padding-top: 10px;">参与课程进度</p>
                <p style="font-size: 35px;padding-top: 10px;">{{courseStat.do + '/' + courseStat.total}}</p>
              </div>
            </el-col>
            <el-col :span="8">
              <div style="text-align: center;">
                <p style="font-size: 20px;padding-top: 10px;">参与直播进度</p>
                <p style="font-size: 35px;padding-top: 10px;">{{liveStat.do + '/' + liveStat.total}}</p>
              </div>
            </el-col>
            <el-col :span="8">
              <div>
                <p style="font-size: 20px;padding-top: 10px;">出勤/缺勤/迟到/早退</p>
                <p style="font-size: 35px;padding-top: 10px;">{{checkStat.do + '/' + checkStat.undo + '/' + checkStat.late + '/' + checkStat.leaveearly}}</p>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <p style="font-size: 24px;padding-left: 20px">{{'直播数（' + totalCount + '）'}}</p>
    </el-row>
    <el-row type="flex" justify="space-between">
      <el-col :span="12">
        <el-row style="padding-left: 20px;padding-top: 10px">
          <el-input v-model="searchInfo.searchTitleKey" placeholder="请输入直播名称" style="width: 200px"
          @keyup.enter.native="titleInputEnter"></el-input>
          <el-select v-model="searchInfo.searchStatusKey" placeholder="请选择"
                     @change="searchStatusChange"
                     style="padding-left: 10px">
            <el-option
              v-for="item in liveStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row style="padding-right: 20px;padding-top: 10px;">
          <div style="text-align: right">
            <el-date-picker
              v-model="searchInfo.searchDateRange"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="searchDateChange"
              :picker-options="pickerOptions">
            </el-date-picker>
            <el-button type="primary" style="margin-left: 20px" @click="searchBtnClick">搜索</el-button>
          </div>

        </el-row>
      </el-col>
    </el-row>
    <div class="table_container">
      <el-table
        :data="dataList"
        :header-cell-style="{background:'#eef1f6',color:'#606266',textAlign:'center'}"
        style="width: 100%">
        <el-table-column
          label="直播名称">
          <template slot-scope="props">
            <div style="text-align: center">
              <span>{{ props.row.title }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="课程名称">
          <template slot-scope="props">
            <div style="text-align: center">
              <span>{{ props.row.coursetitle }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="直播时间" width="200">
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ formatLiveTime(props.row.begintime, props.row.endtime) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="直播状态" >
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ formatLiveStatusTime(props.row.status) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="听课类型" >
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ props.row.playtype === 1 ? '直播' : '回放'}}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="班型" >
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ formatLiveScale(props.row.scale) }}</p>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="实际上课时长">
          <template slot-scope="props">
            <div style="text-align: center">
              <p> {{ props.row.online }}</p>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="Pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageCount"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from '../../components/TopHeader'
export default {
  name: 'StudentInfo',
  components: {TopHeader},
  data () {
    return {
      liveStatusList: [{label: '全部', value: -1}, {label: '未开始', value: 0}, {label: '直播中', value: 1}, {label: '已结束', value: 2}],
      pickerOptions: {
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '昨天',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', [date, date])
          }
        },
        {
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      searchInfo: {searchStatusKey: -1},
      dataList: [],
      studentInfo: {},
      currentPage: 1,
      pageCount: 10,
      totalCount: 0,
      liveStat: {do: 0, total: 0},
      checkStat: {do: 0, late: 0, leaveearly: 0, undo: 0},
      courseStat: {do: 0, total: 0}
    }
  },
  created () {
    this.getCurData()
  },
  watch: {
    '$route': {
      handler (route) {
        const that = this
        if (route.path === '/studentInfo') {
          console.log('----', route.path)
          this.searchInfo = {searchStatusKey: -1}
          that.getCurData()
        }
      },
      deep: true
    }
  },
  methods: {
    getCurData () {
      this.getStudentInfo()
      this.getStuLiveStat()
      this.getStuCheckStat()
      this.searchBtnClick()
      this.getStuCourseStat()
    },
    searchBtnClick () {
      let requestData = {count: this.pageCount, page: this.currentPage, mobile: this.$route.query.mobile}
      let liveTitle = this.searchInfo.searchTitleKey
      let searchStatusKey = this.searchInfo.searchStatusKey
      let dateRange = this.searchInfo.searchDateRange
      if ((liveTitle !== undefined && liveTitle !== '') ||
          searchStatusKey !== -1 ||
        (dateRange !== undefined && dateRange !== null && dateRange.length > 1)) {

        if (dateRange !== undefined && dateRange !== null && dateRange.length > 1) {
          requestData.begintime = this.formatDate('YYYY-mm-dd', dateRange[0]) + ' 00:00:00'
          requestData.endtime = this.formatDate('YYYY-mm-dd', dateRange[1]) + ' 23:59:59'
        }
        if (searchStatusKey !== -1) {
          requestData.status = searchStatusKey
        }
        if (liveTitle !== undefined && liveTitle !== '') {
          requestData.title = liveTitle
        }

        this.$api.userInfo.getStuUserLiveInfoSearchStat(requestData).then((res) => {
          if(res.code === 0) {
            if (res.data instanceof Array) {
              this.dataList = res.data
              this.totalCount = res.totalCount
            } else {
              this.dataList = []
              this.totalCount = 0
            }

            console.log(this.dataList)
          }
        })

      } else {
        this.$api.userInfo.getStuUserLiveInfoStat(requestData).then((res) => {
          if(res.code === 0) {
            this.dataList = res.data
            this.totalCount = res.totalCount
            console.log(this.dataList)
          } else {
            this.dataList = []
            this.totalCount = 0
          }
        });
      }

    },
    getStudentInfo () {
      let requestData = {mobile:this.$route.query.mobile}
      this.$api.userInfo.getStuUserInfo(requestData).then((res) => {
        if(res.code === 0) {
          this.studentInfo = res.data;
        } else {
          this.studentInfo = {nickname: '学生'}
        }
      });
    },
    getStuLiveStat () {
      let requestData = {mobile:this.$route.query.mobile}
      this.$api.userInfo.getStuUserLiveStat(requestData).then((res) => {
        if(res.code === 0) {
          this.liveStat = res.data;
        } else {
          this.liveStat = {do: 0,total:0}
        }
      });
    },
    getStuCheckStat () {
      let requestData = {mobile:this.$route.query.mobile}
      this.$api.userInfo.getStuUserCheckStat(requestData).then((res) => {
        if(res.code === 0) {
          this.checkStat = res.data;
        } else {

          this.checkStat = {do: 0, late: 0, leaveearly: 0, undo: 0}
        }
      });
    },
    getStuCourseStat () {
      let requestData = {mobile:this.$route.query.mobile}
      this.$api.userInfo.getStuUserCourseStat(requestData).then((res) => {
        if(res.code === 0) {
          this.courseStat = res.data;
        } else {

          this.courseStat = {do: 0, total: 0}
        }
      });

    },
    titleInputEnter () {
      // this.searchBtnClick()
    },
    searchStatusChange () {
      // this.searchBtnClick()
    },
    searchDateChange () {
      // this.searchBtnClick()
    },
    handleSizeChange (val) {
      this.pageCount = val
      this.currentPage = 1
      this.searchBtnClick()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.searchBtnClick()
    },
    formatLiveScale (scale) {

      if (scale === '0') {
        return '小班'
      } else if (scale === '1') {
        return '大班'
      } else if (scale === '5') {
        return '双师'
      }
    },
    formatLiveStatusTime (liveStatus) {
      if (liveStatus === 0) {
        return '未开始'
      } else if (liveStatus === 1) {
        return '直播中'
      } else if (liveStatus === 2) {
        return '已结束'
      }
    },
    formatLiveTime (beginTime, endTime) {
      let beginDate = new Date(beginTime)
      let endDate = new Date(endTime)
      let timeStr = this.formatDate('YYYY-mm-dd HH:MM', beginDate) + ' - ' + this.formatDate('HH:MM', endDate)
      return timeStr
    },
    formatDate (fmt, dateStr) {
      let date = new Date(dateStr)
      let ret
      let opt = {
        'Y+': date.getFullYear().toString(),
        'm+': (date.getMonth() + 1).toString(),
        'd+': date.getDate().toString(),
        'H+': date.getHours().toString(),
        'M+': date.getMinutes().toString(),
        'S+': date.getSeconds().toString()
      }
      for (let k in opt) {
        ret = new RegExp('(' + k + ')').exec(fmt)
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length === 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, '0')))
        };
      };
      return fmt
    }
  }
}
</script>

<style scoped>
  .top-container{
    padding: 20px;
  }
  .tea-info-container{
    background-color: #EFF1F6;
    height: 130px;
  }
  .tea-info-left{
    margin-left: 10px;
    margin-top: 25px;
    width: 80px;
    height: 80px;
    float: left;
    border-radius: 40px;
  }
  .tea-info-right{
    height: 100%;
    margin-left: 100px;
  }
  .table_container{
    padding: 20px;
  }
  .Pagination{
    text-align: center;
  }
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    text-align: justify;
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }
</style>



// WEBPACK FOOTER //
// src/page/userManager/StudentInfo.vue